// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	/**
	 * Source of funds needs to be checked
	 */
	if (!optionsListValueSelected(fields.futur_kyc_juridisk_source)) {
		return false;
	}

	/**
	 * We need to know if this is a foreign entity or not
	 */
	if (!optionsListValueSelected(fields.futur_kyc_juridisk_is_foreign)) {
		return false;
	}

	/**
	 * Foreign entity checks
	 */
	if (fields.futur_kyc_juridisk_is_foreign.options[1].checked) {
		/**
		 * Tax residency country needs to be selected from the list
		 */
		if (fields.futur_kyc_juridisk_tax_residency_country.length === 0) {
			return false;
		}

		/**
		 * TIN needs to be either given or a reason for selected for why not
		 */
		if (fields.futur_kyc_juridisk_tax_residency_tin_missing.checked) {
			/**
			 * TIN is missing was checked. In that case we need to give a reason
			 */
			if (!optionsListValueSelected(fields.futur_kyc_juridisk_tax_residency_tin_missing_reason)) {
				return false;
			}

			/**
			 * If we select "other" as reason, we need to specify it in text
			 */
			if (fields.futur_kyc_juridisk_tax_residency_tin_missing_reason.options[1].checked && fields.futur_kyc_juridisk_tax_residency_tin_missing_reason_other.length === 0) {
				return false;
			}
		}
		else if (fields.futur_kyc_juridisk_tax_residency_tin.length === 0) {
			return;
		}
	}


	/**
	 * If other source of funds selected it needs to be entered manually
	 */
	if (fields.futur_kyc_juridisk_source.options[5].checked && fields.futur_kyc_juridisk_source_other.length === 0) {
		return false;
	}

	/**
	 * Type of company needs to be checked
	 */
	if (!optionsListValueSelected(fields.futur_kyc_juridisk_type)) {
		return false;
	}

	/**
	 * If other company we need to check either passive or active
	 */
	if (fields.futur_kyc_juridisk_type.options[5].checked && !optionsListValueSelected(fields.futur_kyc_juridisk_passive)) {
		return false;
	}

	/**
	 * If you have an active company, you should select another option
	 */
	if (fields.futur_kyc_juridisk_type.options[5].checked && fields.futur_kyc_juridisk_passive.options[0].checked) {
		return false;
	}

	/**
	 * Beneficial owner exists needs to be checked either yes or no
	 */
	if (!optionsListValueSelected(fields.futur_kyc_juridisk_has_bo)) {
		return false;
	}

	if (fields.futur_kyc_juridisk_has_bo.options[1].checked && !optionsListValueSelected(fields.futur_kyc_juridisk_100_owned)) {
		return false;
	}

	/**
	 * Beneficial owner outside Sweden needs to be checked no
	 */
	if (!optionsListValueSelected(fields.futur_kyc_bo_outside_sweden) || fields.futur_kyc_bo_outside_sweden.options[1].checked) {
		return false;
	}

	/**
	 * Beneficial owner not US person needs to be checked no
	 */
	if (!optionsListValueSelected(fields.futur_kyc_bo_us_persons) || fields.futur_kyc_bo_us_persons.options[1].checked) {
		return false;
	}

	/**
	 * Listed question needs to be answered
	 */
	if (!optionsListValueSelected(fields.futur_kyc_listed_question)) {
		return false;
	}

	if (fields.futur_kyc_listed_question.options[1].checked && !optionsListValueSelected(fields.futur_kyc_juridisk_is_listed)) {
		return false;
	}

	return true;
}

function optionsListValueSelected(optionsList) {
	const options = optionsList.options;
	for (let i = 0; i < options.length; i++) {
		if (options[i].checked) {
			return true;
		}
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/KycJuridiskPerson/KycJuridiskPerson.fulfillment.js